import React from 'react';
import { Navigate, Route, useParams } from 'react-router-dom';
import { OncoAgentAuthGate } from './OncoAgentAuthGate';
import { OncoAgentAppShell } from './OncoAgentAppShell';
import { OncoAgentHome } from './OncoAgentHome';
import { OncoAgentPathways } from './OncoAgentPathways';
import { OncoAgentBilling } from './OncoAgentBilling';
import { OncoAgentSettings } from './OncoAgentSettings';
import { OncoAgentRefer } from '../pages/OncoAgentRefer';
import { OncoAgentInbox } from '../pages/OncoAgentInbox';
import { OncoAgentClinic } from '../pages/OncoAgentClinic';
import { OncoAgentVertical } from '../pages/OncoAgentVertical';

function LegacyVerticalRedirect(): React.ReactElement {
  const { verticalId } = useParams();
  return <Navigate to={`/oncoagent/app/pathways/${verticalId || 'oral'}`} replace />;
}

export function oncoAgentAppRoute() {
  return (
    <Route
      key="oncoagent-app"
      path="/oncoagent/app"
      element={
        <OncoAgentAuthGate>
          <OncoAgentAppShell />
        </OncoAgentAuthGate>
      }
    >
      <Route index element={<OncoAgentHome />} />
      <Route path="refer" element={<OncoAgentRefer />} />
      <Route path="inbox" element={<OncoAgentInbox />} />
      <Route path="clinic" element={<OncoAgentClinic />} />
      <Route path="pathways" element={<OncoAgentPathways />} />
      <Route path="pathways/:verticalId" element={<OncoAgentVertical />} />
      <Route path="billing" element={<OncoAgentBilling />} />
      <Route path="settings" element={<OncoAgentSettings />} />
      <Route path="verticals/:verticalId" element={<OncoAgentVertical />} />
    </Route>
  );
}

export function oncoAgentLegacyRedirects() {
  return [
    <Route key="oa-ref" path="/oncoagent/refer" element={<Navigate to="/oncoagent/app/refer" replace />} />,
    <Route key="oa-in" path="/oncoagent/inbox" element={<Navigate to="/oncoagent/app/inbox" replace />} />,
    <Route
      key="oa-cl"
      path="/oncoagent/clinic"
      element={<Navigate to="/oncoagent/app/clinic" replace />}
    />,
    <Route
      key="oa-vert"
      path="/oncoagent/verticals/:verticalId"
      element={<LegacyVerticalRedirect />}
    />,
  ];
}
